import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



const __default__ = {
  name: 'FrSkeleton',
  inheritAttrs: false,
  customOptions: {}
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  width: {
    type: [String, Number],
    default: () => '100%'
  },
  height: {
    type: [String, Number],
    default: () => '1.25rem'
  },
  circle: {
    type: Boolean,
    default: () => false
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    style: { width: __props.width, height: __props.circle ? __props.width : __props.height },
    class: ["fr-skeleton", { circle: __props.circle }]
  }), null, 16))
}
}

})